'use strict';

var Caml_option = require("bs-platform/lib/js/caml_option.js");

function _getKey(k) {
  switch (k) {
    case /* Token */0 :
        return "token";
    case /* Mode */1 :
        return "mode";
    case /* Type */2 :
        return "type";
    
  }
}

function get(k) {
  return Caml_option.nullable_to_opt(window.localStorage.getItem(_getKey(k)));
}

function set(k, v) {
  window.localStorage.setItem(_getKey(k), v);
  return /* () */0;
}

function clear(param) {
  window.localStorage.clear();
  return /* () */0;
}

exports._getKey = _getKey;
exports.get = get;
exports.set = set;
exports.clear = clear;
/* No side effect */
